import React from 'react';
import { motion } from 'framer-motion';
import { Countdown } from './Countdown';
import { ShieldCheck, Lock, CreditCard } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-24 px-4 bg-brand-dark relative overflow-hidden" data-id="element-73">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-brand-primary/10 via-brand-dark to-brand-dark pointer-events-none" data-id="element-74" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-75">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-5xl md:text-6xl font-serif text-brand-cream-light mb-12" data-id="element-76">
          La próxima toma puede ser diferente.
        </motion.h2>

        <div className="mb-12" data-id="element-77">
          <p className="text-brand-accent font-bold mb-6" data-id="element-78">
            ⏰ EL PRECIO CIERRA EN:
          </p>
          <Countdown data-id="element-79" />
        </div>

        <div className="flex flex-col gap-6 max-w-2xl mx-auto mb-12" data-id="element-80">
          <motion.a href="https://www.mamasincaos.store/cart/53013040890153:1" target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="flex flex-col md:flex-row items-center justify-between p-6 bg-brand-darker border border-brand-primary/30 rounded-2xl hover:border-brand-accent transition-colors group" data-id="element-81">
            <div className="text-left mb-4 md:mb-0" data-id="element-82">
              <h3 className="text-xl font-bold text-brand-cream-light" data-id="element-83">
                🍼 S.O.S. LACTANCIA PACK
              </h3>
              <p className="text-brand-primary" data-id="element-84">
                <span className="line-through text-sm mr-2" data-id="element-85">$89.000</span>{' '}
                <span className="font-bold text-brand-cream" data-id="element-86">$19.990 ARS</span>
              </p>
            </div>
            <span className="bg-brand-primary/20 text-brand-accent px-6 py-3 rounded-xl font-bold group-hover:bg-brand-accent group-hover:text-brand-darker transition-colors w-full md:w-auto text-center" data-id="element-87">
              → QUIERO MI PACK
            </span>
          </motion.a>

          <motion.a href="https://www.mamasincaos.store/cart/53013045117225:1" target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="flex flex-col md:flex-row items-center justify-between p-6 bg-gradient-to-r from-brand-primary/20 to-brand-darker border-2 border-brand-gold rounded-2xl shadow-[0_0_30px_rgba(212,168,83,0.1)] group" data-id="element-88">
            <div className="text-left mb-4 md:mb-0" data-id="element-89">
              <h3 className="text-xl font-bold text-brand-gold" data-id="element-90">
                🏆 PACK + MAMÁ BAJO CONTROL ⭐
              </h3>
              <p className="text-brand-primary" data-id="element-91">
                <span className="line-through text-sm mr-2" data-id="element-92">$119.000</span>{' '}
                <span className="font-bold text-brand-cream" data-id="element-93">$27.990 ARS</span>
              </p>
            </div>
            <span className="bg-brand-gold text-brand-darker px-6 py-3 rounded-xl font-bold group-hover:bg-[#e5b964] transition-colors w-full md:w-auto text-center" data-id="element-94">
              → QUIERO EL PACK COMPLETO
            </span>
          </motion.a>
        </div>

        <div className="flex flex-wrap justify-center gap-x-8 gap-y-4 text-sm text-brand-primary" data-id="element-95">
          <span className="flex items-center gap-2" data-id="element-96">
            <Lock size={16} className="text-brand-accent" data-id="element-97" /> Pago 100% seguro
          </span>
          <span className="flex items-center gap-2" data-id="element-98">
            <span className="text-brand-accent" data-id="element-99">⚡</span> Acceso en 5 minutos
          </span>
          <span className="flex items-center gap-2" data-id="element-100">
            <ShieldCheck size={16} className="text-brand-accent" data-id="element-101" /> Garantía 7
            días
          </span>
          <span className="flex items-center gap-2" data-id="element-102">
            <CreditCard size={16} className="text-brand-accent" data-id="element-103" /> Mercado Pago
            | Tarjeta | Transferencia
          </span>
        </div>
      </div>
    </section>;
}